const isFallback = (img: string): boolean =>
  !!(img?.match(/((\/(default-normal)))\b/g) || img?.match(/((\/(default-normal-fr)))\b/g));

export default isFallback;
